import { useContext } from 'react';
import { z } from 'zod';

import { FormSchemaContext } from './FormSchemaContext';

const isFieldRequired = (
  schema: z.ZodTypeAny | undefined,
  fieldName: string,
): boolean => {
  if (schema instanceof z.ZodObject) {
    const field = (schema as z.ZodObject<z.ZodRawShape>).shape[fieldName];

    if (!field) {
      return false;
    }

    return !(field.isOptional() || field.isNullable());
  }

  if (schema instanceof z.ZodEffects) {
    return isFieldRequired(schema._def.schema, fieldName);
  }

  return false;
};

export const useFieldIsRequired = (fieldName: string) => {
  const context = useContext(FormSchemaContext);

  return isFieldRequired(context?.schema, fieldName);
};
